import { CheckoutContracts } from '../../models/checkout/checkout-contracts.interface';
import { mockCheckoutContractAttributes } from '../global-checkout/checkout-contract-attributes.mock';
import { mockCheckoutContractItemDetails } from './checkout-contract-item-details.mock';

export const mockCheckoutContracts: CheckoutContracts = {
  contractAttributes: mockCheckoutContractAttributes,
  itemDetails: mockCheckoutContractItemDetails,
};
